import { ActionTypes } from '../actions';

const INITIAL_STATE = {
  positiveResponses: [],
  negativeResponses: [],
};

const ResponseReducer = (state = INITIAL_STATE, action) => { // changes state value by 1
  switch (action.type) {
    case ActionTypes.UPDATE_RESPONSES:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default ResponseReducer;
